const loadMeetingsWithClick = () => {
  if (document.querySelector('.index-meetings-button')) {
    document.querySelector('.index-meetings-button').click();
  }
}

export { loadMeetingsWithClick };
